import {
    byteArrayToBase64,
    encodeBase64Attachment,
} from '@qdabra/infopath-attachments';

// most of this code was migrated from the now deleted utilFileHandling.js

function checkFileApis() {
    if (!(self.File && self.FileReader)) {
        return Error('File upload is not supported for this browser.');
    }

    return null;
}

function addReaderEvents(fileReader, resolve, reject, progress) {
    fileReader.onload = function (e) {
        resolve(e.target.result);
    };

    fileReader.onerror = function () {
        reject(new Error('An error occurred loading the file.'));
    };

    fileReader.onabort = function () {
        reject(new Error('File load was aborted.'));
    };

    if (progress) {
        fileReader.onprogress = function (e) {
            progress({ loaded: e.loaded, total: e.total });
        };
    }
}

// File -> ArrayBuffer
function getFileBytesAsync(file) {
    return new Promise(function (resolve, reject, progress) {
        var reader = new FileReader();
        var error = checkFileApis();

        if (error) {
            throw error;
        }

        addReaderEvents(reader, resolve, reject, progress);

        reader.readAsArrayBuffer(file);
    });
}

// File -> { name: String, bytes: ArrayBuffer }
export async function loadFileAsync(file) {
    const bytes = await getFileBytesAsync(file);

    return { name: file.name, bytes };
}

export async function blobToBase64Async(blob, base64Type) {
    const loadedFile = await loadFileAsync(blob);
    const array = new Uint8Array(loadedFile.bytes);

    if (base64Type === 'file') {
        return encodeBase64Attachment(array, loadedFile.name);
    }

    if (base64Type === 'image') {
        return byteArrayToBase64(array);
    }

    throw new Error('Unexpected encoding type: ' + base64Type);
}
